import React, { Component } from 'react';
import { Button, Icon } from 'semantic-ui-react'

class WhatsappButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {

        // const genericButton = <p>
        //     <Button ><Icon name='shop' />
        //         <a href={'https://api.whatsapp.com/send?phone=256' + this.props.order.phone} target="_blank">SEND MESSAGE
        //     </a>
        //     </Button>
        // </p>;

        // const depositReminder = <p>
        //     <Button ><Icon name='money' />
        //         <a href={'https://api.whatsapp.com/send?phone=256'
        //             + this.props.order.phone + '&text=Hello%2C%20this%20is%20a%20reminder%20to%20pay%20the%2050%25%20deposit%20on%20your%20order%2C%20so%20that%20we%20can%20start%20with%20the%20printing.%20Thank%20you.%20You%20can%20send%20to%200757477399%20-%20Rhoda%20Nalubega%20or%200778%20086758%20-%20Joseph%20Masendi'} target="_blank">
        //             DEP REMINDER
        //         </a>
        //     </Button>
        // </p>;

        const sendDesign = 
            <div>
                <Button ><Icon name='money' />
                <a href={'https://api.whatsapp.com/send?phone=256'
                    + this.props.order.phone + '&text=Please%20let%20us%20know%20what%20you%20think%20of%20this%20design'} target="_blank">
                    SEND DESIGN
            </a>
            </Button>
            </div>
        ;


        // const callButton = <p>
        //     <Button ><Icon name='phone' />
        //     <a href={"tel:"+this.props.order.phone}>CALL</a>
        //     </Button>
        // </p>;

        return (
            <div>
                {sendDesign}
            </div>);
    }
}

export default WhatsappButtons;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappButtons.js